@if (routerLink(); as link) {
<a [routerLink]="link" [ngClass]="buttonClasses()" class="inline-flex">
  @if (variant() === 'link' && iconLeft()) {
  <span
    class="material-symbols-outlined flex-shrink-0 transition-transform group-hover:-translate-x-1"
    [ngClass]="iconSizeClass()"
    >{{ iconLeft() }}</span
  >
  } @if (label() && variant() === 'link') {
  <span class="font-medium text-primary group-hover:underline"
    >{{ label() }}</span
  >
  } @if (variant() === 'link' && iconRight()) {
  <span
    class="material-symbols-outlined flex-shrink-0 transition-transform group-hover:translate-x-0.5"
    [ngClass]="iconSizeClass()"
    >{{ iconRight() }}</span
  >
  } @if (variant() !== 'link') {
  <ng-content></ng-content>
  @if (isLoading()) {
  <svg
    class="animate-spin -ml-1 h-5 w-5 text-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    ></circle>
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
  } @if (!isLoading() && imageLeft()) {
  <img [src]="imageLeft()" class="w-5 h-5 flex-shrink-0" alt="Icon" />
  } @if (!isLoading() && iconLeft() && variant() !== 'link') {
  <span
    class="material-symbols-outlined flex-shrink-0"
    [ngClass]="iconSizeClass()"
    >{{ iconLeft() }}</span
  >
  } @if (label()) {
  <span class="whitespace-nowrap">{{ label() }}</span>
  } @if (imageRight()) {
  <img [src]="imageRight()" class="w-5 h-5 flex-shrink-0" alt="Icon" />
  } @if (iconRight()) {
  <span
    class="material-symbols-outlined flex-shrink-0"
    [ngClass]="iconSizeClass()"
    >{{ iconRight() }}</span
  >
  } }
</a>
} @else {
<button
  [type]="type()"
  [disabled]="disabled() || isLoading()"
  (click)="onClick($event)"
  [ngClass]="buttonClasses()"
>
  <ng-content></ng-content>

  @if (isLoading()) {
  <svg
    class="animate-spin -ml-1 h-5 w-5 text-current"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      class="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      stroke-width="4"
    ></circle>
    <path
      class="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
  } @if (!isLoading() && imageLeft()) {
  <img [src]="imageLeft()" class="w-5 h-5 flex-shrink-0" alt="Icon" />
  } @if (!isLoading() && iconLeft()) {
  <span
    class="material-symbols-outlined flex-shrink-0"
    [ngClass]="iconSizeClass()"
    >{{ iconLeft() }}</span
  >
  } @if (label()) {
  <span class="whitespace-nowrap">{{ label() }}</span>
  } @if (imageRight()) {
  <img [src]="imageRight()" class="w-5 h-5 flex-shrink-0" alt="Icon" />
  } @if (iconRight()) {
  <span
    class="material-symbols-outlined flex-shrink-0 transition-transform"
    [ngClass]="[iconSizeClass(), variant() === 'link' ? 'group-hover:translate-x-0.5' : '']"
    >{{ iconRight() }}</span
  >
  }
</button>
}
